module.exports = __webpack_public_path__ + "static/media/digha.20c4fc24.jpg";